import React from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Button,
  Divider,
  makeStyles,
  Paper,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core";
import { CircularProgress } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import DescriptionIcon from "@material-ui/icons/Description";
import DeleteOutlineIcon from "@material-ui/icons/Close";
import MinimizeIcon from "@material-ui/icons/FullscreenExit";
import ExpandLessIcon from "@material-ui/icons/Fullscreen"; 
import CheckCircleOutlineOutlined from '@material-ui/icons/CheckCircleOutlineOutlined';
import CheckCircleOutline from '@material-ui/icons/CheckCircle';
import NewReleasesOutlined from '@material-ui/icons/Error';
import DocuwareTemplateService from "../../services/DocuwareTemplateService";
import notify from "../../utils/notifier";



const useStyles = makeStyles((theme) => ({
    drawerPaper: {
      width: "30%", 
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#F6F6F6", 
      zIndex: 5
    },
    titleBar: {
        display: "flex",
        justifyContent: "space-between",
        gap: theme.spacing(2),
        alignItems: "center",
        backgroundColor: "#fff",
        paddingLeft: '20px'
    },
    bottomTitleBar: {
        display: "flex",
        justifyContent: "space-between",
        gap: theme.spacing(2),
        alignItems: "center",
        backgroundColor: "#fff",
        paddingLeft: '20px',
        paddingRight: '10px',
        paddingTop : '10px',
        paddingBottom : '10px',

    },
    bottomBar: { 
        position: "fixed",
        bottom: 0,
        right: 0,
        width: "30%",
        borderTop: "1px solid #ddd",
        boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
        display: "flex",
        backgroundColor: "#F6F6F6", 
        flexDirection: "column",
        zIndex: 1300
    },
    noteBox: {
      backgroundColor: "#EAF5FB",
      borderRadius: 4,
      padding: '10px',
      margin: theme.spacing(2, 2, 2, 2),
    },
    successNoteBox: {
        flex: 1,
        backgroundColor: "#E6F4EA",   // soft green background
        border: "1px solid #34A853", // Google green
        borderRadius: 4,
        padding: "10px",
        margin: theme.spacing(2, 0, 2, 0),
        color: "#1E4620",
    },  
    errorNoteBox: {
        flex: 1,
        backgroundColor: "#FDECEA",   // soft red background
        border: "1px solid #D93025", // muted error red
        borderRadius: 4,
        padding: "10px",
        display: "flex",                
        justifyContent: "space-between", 
        margin: theme.spacing(2, 0, 2, 0),
        color: "#5F2120",
    },
    warningNoteBox: {
        backgroundColor: "#FDECEA",     // soft red background
        border: "1px solid #D93025",
        borderRadius: 6,
        padding: "10px",
        marginLeft: "16px",
        marginRight: "16px",
        marginBottom: "16px",
        marginTop: "5px",
        color: "#B71C1C",            
        display: "inline-block",       
        width: "auto",                  
        maxWidth: "100%",            
    },

    errorLink: {
        textDecoration: "underline",
        cursor: "pointer",
    },
    headerRow: {
      display: "flex",
      justifyContent: "space-between",
      margin: theme.spacing(1, 2, 2, 2),
    },
    highlight: {
      backgroundColor: "#f6f6f6",
      borderRadius: 4,
      padding: theme.spacing(0.5, 1),
    },
    fileList: {
      flex: 1,     
      overflowY: "auto", // scrollable file list
      padding: theme.spacing(0, 2, 2, 2),
      marginTop:theme.spacing(1)
    },
    fileRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "#fff", // 👈 white rows
      borderRadius: 6,
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    },
    fileInfo: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1),
    },
    fileName: {
      fontWeight: 500,
    },
    sizeText: {
      fontSize: "0.85rem",
      color: "#555",
    },
    actions: {
        borderTop: "1px solid #ddd",
        padding: theme.spacing(2),
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
        backgroundColor: "#fff",
        position: "sticky",
        zIndex: 10,
    }, 
    actionBtn: {
        borderRadius: '25px', 
        padding: theme.spacing(0.75, 2), 
        textTransform: 'none', 
        borderColor: '#0E4B5B', 
        color: '#0E4B5B', 
        fontWeight: 600, 
        '&:hover': { borderColor: '#0E4B5B', backgroundColor: 'rgba(14,75,91,0.08)', } 
    }, 
    cacncelActionBtn: { 
        borderRadius: '25px',
        padding: theme.spacing(0.75, 2),
        textTransform: 'none',
        backgroundColor: '#0E4B5B',
        borderColor: '#0E4B5B', 
        color: "#ffffff", 
        fontWeight: 600, 
        '&:hover': { borderColor: '#0E4B5B', backgroundColor: '#0E4B5B', color: "#ffffff" }, 
        "&:disabled": { backgroundColor: "#ccc", color: "#fff", }
    },
    titleStatusContainer: {
      display: "flex",
      alignItems: "center",
      gap : '7px'
    },
    errorFileRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#FDECEA",        // light red background
        border: "1px dashed #D93025",      // dashed red border
        borderRadius: 6,
        padding: "10px",  
        marginBottom: theme.spacing(1),
    },
    errorMessage: {
        color: "#D93025",                  // dark/muted red
        fontSize: "0.9rem",
        fontWeight: 500,
    },

    dividerStyle:{
        marginBottom: '30px',
        marginTop: '20px'

    }
}));
  


export default function UploadModal({
  open,
  onClose,
  files,
  onRemoveFile
}) {
  const classes = useStyles();
  const [view, setView] = React.useState("drawer");
  const [advancedOptions, setAdvancedOptions] = React.useState({});
  const [state, setState] = React.useState("start");
  const [filesStatus, setFileStatus] = React.useState({});
  const [uploadStatus, setUploadStatus] = React.useState('');
  const [successFiles, setSuccessFiles] = React.useState(0);
  const [errorFiles, setErrorFiles] = React.useState(0);
  const [errorMessage, setErrorMessage] = React.useState({});
  const [manualCategory, setManualCategory] = React.useState(false);
  const [selectedCategory, setSelectedCategory] = React.useState(null);
  const [documentCategories, setDocumentCategories] = React.useState([]);
  



  const totalSize = React.useMemo(() => {
    return (files.reduce((acc, f) => acc + f.size, 0) / (1024 * 1024)).toFixed(2);
  }, [files]);

  const handleSetFileStatus= (id, value) => {    
    setFileStatus(prev => {
        const updated = { ...prev, [id]: value };
        checkGlobalStatus(updated);   // <- check after every update
        return updated;
    });
  }

  const getDocumentCategories =() =>{
    DocuwareTemplateService.getClientFields({q : 'document_category'}).then(response => {
      let clientFieldResponse = response.data;
      if (clientFieldResponse && clientFieldResponse.length >=1) {
        clientFieldResponse = clientFieldResponse[0];
        if (clientFieldResponse["acceptedValues"]){
          setDocumentCategories(clientFieldResponse["acceptedValues"]);
        }
      }
      
    }).catch(error => {
      notify({
        type: 'error',
        message: 'Error fetching the field columns'
      });
  })
  }

  const checkGlobalStatus = (statusMap) => {
    const statuses = Object.values(statusMap);

    const successCount = statuses.filter(s => s === "success").length;
    const errorCount   = statuses.filter(s => s === "error").length;
  
    if (statuses.includes("progress")) {
        setUploadStatus("progress");
    } else if (statuses.includes("error")) {
        setUploadStatus("error");
        setState("done");
        setSuccessFiles(successCount);
        setErrorFiles(errorCount);
    } else if (
      statuses.length > 0 &&
      statuses.every(s => s === "success")
    ) {
      setUploadStatus("success");
      setState("done");
      setSuccessFiles(successCount);
      setErrorFiles(errorCount);
    } else {
      setUploadStatus("");
    }
  };

  const handleConfirmUpload = () => {
    if (files){
        setState("uploading");
        files.map((file, idx) => {
            handleSetFileStatus(idx, "progress");
            DocuwareTemplateService.uploadFile({...advancedOptions, 'documentCategory' : selectedCategory}, file).then(response => {
                handleSetFileStatus(idx, "success");
                // let fileIdentifier = response['fileIdentifier'];
                // if (selectedCategory != null){
                //   DocuwareTemplateService.moveToFolderByFileId(fileIdentifier).then().catch(error => {
                //   console.log(`error while moving the file to folder - ${fileIdentifier}`);
                //   });
                // }

            }).catch(error => {
                setErrorMessage(prev => ({...prev, [idx]: error.message}));
                handleSetFileStatus(idx, "error");
            });
        })
        
    }
  };

  const handleRetryFailedUploads = () => {
    if (files){
        setState("uploading");
        files.map((file, idx) => {
            if (filesStatus[idx]=='error'){
                handleSetFileStatus(idx, "progress");
                DocuwareTemplateService.uploadFile({...advancedOptions, 'documentCategory' : selectedCategory}, file).then(response => {
                    handleSetFileStatus(idx, "success");
                    let fileIdentifier = response['fileIdentifier'];
                    if (selectedCategory != null){
                      DocuwareTemplateService.moveToFolderByFileId(fileIdentifier).then().catch(error => {
                      console.log(`error while moving the file to folder - ${fileIdentifier}`);
                      });
                    }
                }).catch(error => {
                    setErrorMessage(prev => ({...prev, [idx]: error.message}));
                    handleSetFileStatus(idx, "error");
                });
            }
        })
    }
  }

  const handleFinishUpload = () => {
    if (successFiles>0){
        notify({
            type: "success",
            message: `${successFiles} documents uploaded successfully.`
          });
    }
    else if (errorFiles>0){
        notify({
            type: "error",
            message: `${errorFiles} documents failed to upload.`
          });
    }
    handleClose();
  }

  const handleClose = () => {
    setAdvancedOptions({});
    setFileStatus({});
    setState("start");
    setUploadStatus("");
    setSuccessFiles(0);
    setErrorFiles(0);
    setErrorMessage({});
    setView("drawer");
    setManualCategory(false);
    setSelectedCategory(null);
    onClose();
  }

  const getStatusHtml = (value) =>{
    return <>
    {value=== "progress" && (
        <CircularProgress color="inherit" size={20}/>
    )}

    {value === "success"  && (
        <CheckCircleOutline style={{ color: "green" }} />
    )}

    {value === "error" && (
        <NewReleasesOutlined style={{ color: "#D32F2F" }} />
    )}
    </>
  }

  React.useEffect(() => {
    getDocumentCategories();
    console.log('doneee');
}, []);

  if (open && view === "minimized") {
    return (
      <Paper className={classes.bottomBar}>
        <Box className={classes.bottomTitleBar}>
        <Box className={classes.titleStatusContainer}>
          <Typography variant="h6" >Upload Documents</Typography>
          {getStatusHtml(uploadStatus)}
        </Box>
        <Box>
          <IconButton size="small" onClick={() => setView("drawer")}>
            <ExpandLessIcon />
          </IconButton>
          <IconButton size="small" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        </Box>

        {state=='start' &&
        <Box className={classes.noteBox}>
            <Typography variant="body2" color="textSecondary">
            <b>Note :</b> Document upload can’t be cancelled midway. Please confirm
            the selection before you proceed with upload.
            </Typography>
        </Box>
        }

        {state=='uploading' &&
        <Box className={classes.noteBox}>
            <Typography variant="body2" color="textSecondary">
            Uploading <b>{files.length}</b> files
            </Typography>
        </Box>
        }

        {state=='done' &&
        <div style={{marginLeft:'20px', marginRight: '20px'}}>
        <Box className={classes.titleStatusContainer}>
        {successFiles>0 && 
        <Box className={classes.successNoteBox}>
            <Typography variant="body2" color="textSecondary">
            Uploaded <b>{successFiles}</b> files.
            </Typography>
        </Box>
        }
        {errorFiles>0 && 
        <Box className={classes.errorNoteBox}>
            <Typography variant="body2" color="textSecondary">
            <b>{errorFiles}</b> Errors.
            </Typography>
            <Typography
            variant="body2"
            className={classes.errorLink}
            onClick={() => setView("drawer")}
          >
            View
          </Typography>
        </Box>
        }
        </Box>
        </div>
        }

      </Paper>
    );
  }

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      classes={{ paper: classes.drawerPaper }}
    >
      <Box className={classes.titleBar}>
        <Box className={classes.titleStatusContainer}>
            <Typography variant="h6">Upload Documents</Typography>
            {getStatusHtml(uploadStatus)}
        </Box>
        <Box>
          <IconButton onClick={() => setView("minimized")}>
            <MinimizeIcon />
          </IconButton>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      {state=='start' &&
      <>
      <Box className={classes.noteBox}>
        <Typography variant="body2" color="textSecondary">
          <b>Note :</b> Document upload can’t be cancelled midway. Please confirm
          the selection before you proceed with upload.
        </Typography>
      </Box>

      {files.length> 100 && <Box className={classes.warningNoteBox}>
        <Typography variant="body2" color="textSecondary">
          <b>Warning :</b> You can upload a maximum of 20 documents at a time.
        </Typography>
      </Box>}
      

      <Divider />

      <Box className={classes.headerRow}>
        <Typography>
          Documents Selected{" "}
          <span className={classes.highlight}>{files.length}</span>
        </Typography>
        <Typography>
          Upload Size{" "}
          <span className={classes.highlight}>{totalSize} MB</span>
        </Typography>
      </Box>
      </>

      
      }

      {state=='uploading' &&
      <>
      <Box className={classes.noteBox}>
        <Typography variant="body2" color="textSecondary">
          Uploading <b>{files.length}</b> files
        </Typography>
      </Box>

      </>
      }

      

      
      <Box className={classes.fileList}>

      {state=='start' && files.map((file, idx) => (
        <>
        <Box key={idx} className={classes.fileRow}>
          <Box className={classes.fileInfo}>
            <DescriptionIcon color="primary" />
            <Box>
              <Typography className={classes.fileName}>{file.name}</Typography>
              <Typography className={classes.sizeText}>
                {(file.size / 1024).toFixed(0)} KB
              </Typography>
            </Box>
          </Box>
          <IconButton onClick={() => onRemoveFile?.(idx)} size="small">
            <DeleteOutlineIcon />
          </IconButton>
        </Box>


        </>
        
      ))}
      
      {state =='start' &&
       <>
      <Divider />
              

        {/* <Box className={classes.noteBox}>
        <Typography variant="body2" color="textSecondary">
            <b>Note :</b> Document category can be provided explicitly to bypass the classification and run the rules for moving the document.
        </Typography>
        </Box>

        <div style={{ marginTop: "16px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={manualCategory}
                onChange={(e) => setManualCategory(e.target.checked)}
              />
            }
            label="Set Document Category manually"
          />

          {manualCategory && (
            <FormControl fullWidth size="small" style={{ marginTop: "10px" }}>
              <InputLabel>Document Category</InputLabel>
              <Select
                value={selectedCategory || ""}
                label="Document Category"
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                {documentCategories.map((cat) => (
                  <MenuItem key={cat} value={cat}>
                    {cat}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </div> */}
      </>}

      {state=='uploading' && files.map((file, idx) => (
        <Box key={idx} className={classes.fileRow}>
          <Box className={classes.fileInfo}>
            <DescriptionIcon color="primary" />
            <Box>
              <Typography className={classes.fileName}>{file.name}</Typography>
              <Typography className={classes.sizeText}>
                {(file.size / 1024).toFixed(0)} KB
              </Typography>
            </Box>
          </Box>
            {filesStatus[idx] === "progress" && (
                <CircularProgress color="inherit" size={20}/>
            )}

            {filesStatus[idx] === "success"  && (
                <CheckCircleOutlineOutlined style={{ color: "grey" }} />
            )}

            {filesStatus[idx] === "error" && (
                <NewReleasesOutlined style={{ color: "grey" }} />
            )}
        </Box>
        
      ))}

      {state=='done' && 
        <>
         {uploadStatus=='error' &&  <>
         <Box className={classes.errorNoteBox}>
            <Typography variant="body2" color="textSecondary">
            <b>{errorFiles}</b> errorFiles.
            </Typography>
        </Box>

        {files.map((file, idx) => {
            if (filesStatus[idx]=='error'){
              return <Box key={idx} className={classes.errorFileRow}>
              <Box className={classes.fileInfo}>
                <DescriptionIcon color="error" /> 
                <Typography className={classes.fileName}>
                  {file.name}
                </Typography>
              </Box>
              <Typography className={classes.errorMessage}>
                {errorMessage[idx]? errorMessage[idx] :  "Upload failed due to a system error"}
              </Typography>
            </Box>
          }
        })}

        <Divider className={classes.dividerStyle}/>

        </>}

        {successFiles>0 && 
        <>
        <Box className={classes.successNoteBox}>
            <Typography variant="body2" color="textSecondary">
            Uploaded <b>{successFiles}</b> files.
            </Typography>
        </Box>

        {files.map((file, idx) => {
            if (filesStatus[idx]=='success'){
              return <Box key={idx} className={classes.fileRow}>
                <Box className={classes.fileInfo}>
                <DescriptionIcon color="primary" />
                <Box>
                    <Typography className={classes.fileName}>{file.name}</Typography>
                    <Typography className={classes.sizeText}>
                    {(file.size / 1024).toFixed(0)} KB
                    </Typography>
                </Box>
                </Box>
                
                <CheckCircleOutlineOutlined style={{ color: "grey" }} />
              </Box>
          }
        })}
        </>}

       

        </>
      }
      </Box>


      

      {state=='start' &&
      <Box className={classes.actions}>
        <Button onClick={handleClose} variant="outlined" className= {classes.actionBtn}> 
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleConfirmUpload}
          disabled={files.length === 0 || files.length>100}
          className= {classes.cacncelActionBtn}
        >
          Confirm & Upload
        </Button>
      </Box>
      }

     {state=='done' &&<>
      {errorFiles>0 && 
      <Box className={classes.actions}>
        <Button variant="outlined" onClick={handleRetryFailedUploads} className= {classes.actionBtn}> 
          Retry Failed Uploads
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleFinishUpload}
          className= {classes.cacncelActionBtn}
        >
          Proceed with Completed files
        </Button>
      </Box>
      }
      {errorFiles==0 &&
      <Box className={classes.actions}>
        <Button
            color="primary"
            variant="contained"
            onClick={handleFinishUpload}
            className= {classes.cacncelActionBtn}
            >
            Finish Upload
            </Button>
      </Box>
      }
      </>
    }
    </Drawer>
  );
}
